// Webpack Imports
import $ from 'jquery';
import 'bootstrap';


( function () {
	'use strict';
		jQuery(window).on('load', function() {
            jQuery('#myModal').modal('show');
              const textElement = document.getElementById("typewriter-text");
			  const cursorElement = document.getElementById("cursor");
			  const originalText = textElement.textContent;
			  let textIndex = 0;
			  let isCursorVisible = true;

			  function toggleCursor() {
			    if (isCursorVisible) {
			      cursorElement.style.display = "none";
			    } else {
			      cursorElement.style.display = "inline";
			    }
			    isCursorVisible = !isCursorVisible;
			  }

			  function typeText() {
			    if (textIndex < originalText.length) {
			      textElement.textContent += originalText.charAt(textIndex);
			      textIndex++;
			      setTimeout(typeText, 50); // Adjust the delay (in milliseconds) for typing speed
			    } else {
			      toggleCursor();
			    }
			  }

			  textElement.textContent = ''; // Clear the original text
			  setInterval(toggleCursor, 500); // Adjust the cursor blink rate (in milliseconds)
			  setTimeout(typeText, 1000); // Adjust the delay 
        });

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();